<template>
    <modal v-model="show"
           maxWidth="600"
           @input="onInput">

        <div class="close"
             @click="closeModal">&times;</div>

        <app-button v-if="!noActivator"
                    class="extra-field-create-activator btn btn-primary_bottom"
                    slot="activator"
                    :label="$t('message.loginPersonalize.message.createRegistrationFormField')"
                    icon="plus-circle-outline"
                    flat
                    underline
                    primary
                    @click="openModalAndReset">

        </app-button>

        <app-form @submit="validate">
            <div class="form-body">
                <h1 class="text-muted text-center">
                    {{$t('message.loginPersonalize.message.registrationField')}}
                </h1>

                <app-stepper-section :label="$t('message.loginPersonalize.message.fieldType')" class="type-extraField">
                    <app-select class="type-body" v-model="form.type" :data-title="$t('message.spots.message.select')"
                                :data-search="false"
                                :data-items="extraFieldsType"
                                :clearable="true"
                                />
                </app-stepper-section>

                

                <text-field ref="firstInput"
                            :label="$t('message.loginPersonalize.message.fieldName')"
                            :name="$t('message.loginPersonalize.message.fieldName')"
                            validate="required"
                            :help="$t('message.loginPersonalize.message.fieldNameHelp')"                            
                            v-model="form.name"
                            @blur="setLabel"/>
                <text-field :label="$t('message.loginPersonalize.message.fieldLabel')"
                            :name="$t('message.loginPersonalize.message.fieldLabel')"
                            validate="required"
                            :help="$t('message.loginPersonalize.message.fieldLabelHelp')"
                            v-model="form.label"/>
                <div v-if="isTextType">
                    <app-stepper-section :label="$t('message.loginPersonalize.message.maskType')" class="type-mask">
                        <app-select class="type-body" v-model="form.placeholder" :data-title="$t('message.spots.message.select')"
                                    :data-search="false"
                                    :data-items="placeholderOptions"
                                    :clearable="true"
                                    />
                    </app-stepper-section>
                    <v-text-field disabled
                                v-validate="'required'"
                                name="Máscara"
                                :error-messages="errors.collect('Máscara')"
                                :value="form.placeholder"></v-text-field>
                </div>
                <!-- <v-textarea   v-if="form.type === 'OPTION'"
                            key="form-type"
                            v-validate="'required'"
                            :error-messages="errors.collect($t('message.loginPersonalize.message.options'))"
                            :label="$t('message.loginPersonalize.message.options')"
                            name="Opções"
                            no-resize
                            v-model="form.options"></v-textarea> -->
                <div class="chips-container" v-if="form.type === 'OPTION'">
                    <div class="chips-inner-container">
                        <div class="chips-wrapper">
                            <div v-for="(chip, index) in chips" :key="index" class="chip">
                                {{ chip }}
                                <div class="v-chip-close" @click="chipRemove(index)">
                                
                                    <i class="mdi mdi-close"></i>
                                </div>

                            </div>
                        </div>
                        <v-text-field class="input" v-model="inputValue" @keydown.enter.prevent="addChip" @keydown.delete="backspaceDelete" 
                            :placeholder="$t('message.loginPersonalize.message.addOptionAndPressEnter')"></v-text-field>
                    </div>


                    <!-- <div class="all-chip-close">
                        <i @click="allChipsRemove" v-show="showTest" class="mdi mdi-close"></i>
                    </div> -->

                </div>              
            </div>

            <div class="card-footer">
                <button class="btn btn-primary btn-round"
                        type="submit">
                    {{item ? $t('message.generics.message.save') : $t('message.loginPersonalize.message.create')}}
                </button>
            </div>
        </app-form>
    </modal>
</template>

<script>
import AppSelect from '@components/Select'
import EventBus from "@packages/event-bus";
import AppButton from "@components/generic/button/Button";
import Modal from "@components/generic/Modal";
import AppStepperSection from "@components/StepperSection";
import TextField from '@components/form/TextField.vue';
import AppForm from "@components/form/Form.vue";

export default {
    components: {
        AppSelect,
        AppStepperSection,
        AppButton,
        Modal,
        TextField,
        AppForm
    },

    data() {
        return {
            controlTypes: [],
            show: false,
            form: {
                name: undefined,
                label: undefined,
                placeholder: undefined,
                type: undefined,
                options: undefined,
            },
            inputValue: '',
            chips: [],
            showTest: false,
            set: true,
        };
    },

    mounted() {},

    props: {
        item: {
            type: Object,
        },
        manualShow: {
            type: Boolean,
            default: false,
        },
        noActivator: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        manualShow(showVal) {
            this.show = showVal;

            if (showVal) {
                this.reset();
            }
        },        
    },

    computed: {
        extraFieldsType() {
            return [
                {id: 'BOOLEAN', label: this.$t('message.loginPersonalize.message.boolean')},
                {id: 'TEXT', label: this.$t('message.loginPersonalize.message.text')},
                {id: 'OPTION', label: this.$t('message.loginPersonalize.message.options')}
            ]
        },
        isTextType() {
            return this.form.type === "TEXT"
        },
        placeholderOptions() {
            return [
                {id: '00.000.000/0000-00', label: 'CNPJ'},
                {id: '000.000.000-00', label: 'CPF'},
                {id: '(00)00000-0000', label: 'Telefone'},
                {id: '0000000', label: 'RG'},
                {id: '0', label: this.$t('message.loginPersonalize.message.number0to9')},
                {id: '0#', label: this.$t('message.loginPersonalize.message.numbers0to9')},
                {id: 'S', label: this.$t('message.loginPersonalize.message.letter')},
                {id: 'A', label: this.$t('message.loginPersonalize.message.acceptAll')},
            ]
        },
        establishmentId() {
            return this.$store.state.users.user.accountId
        },        

    },

    methods: {
        addChip() {
            if (this.inputValue.length) {
                ((this.set && this.chips.indexOf(this.inputValue) === -1) || !this.set) && this.chips.push(this.inputValue);
                this.inputValue = ''
                this.showTest = true
            }
        },
        backspaceDelete({ which }) {
            which == 8 && this.inputValue === '' && this.chips.splice(this.chips.length - 1);
        },

        chipRemove(index) {
            this.chips.splice(index, 1)
        },

        allChipsRemove() {
            this.chips.splice(0)
            this.showTest = false
        },
        openModalAndReset() {
            this.show = true;

            this.reset();
        },
        closeModal() {
            this.show = false;
            this.$emit("closed");
        },
        onInput() {
            if (this.show) {
                this.$nextTick(() => {
                    this.$refs.firstInput.focus();
                });
            } else {
                this.$emit("closed");
            }
        },
        async reset() {
            if (this.item) {
                this.form = {
                    id: this.item.id,
                    name: this.item.name,
                    label: this.item.label,
                    placeholder: this.item.placeholder,
                    type: this.item.type,
                    options: this.item.options 
                };
                this.chips = this.item.options ? [...this.item.options] : [] 
            } else {
                this.form = {
                    name: undefined,
                    label: undefined,
                    placeholder: undefined,
                    type: undefined,
                    options: undefined
                };
            }
        },
        async validate() {
            if(!this.form.type) {
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: "Selecione o tipo do campo!",
                });
                return
            }

            const isValid = await this.$validator.validateAll();

            if (isValid) {
                this.save();
            }
        },
        async save() {
            EventBus.$emit("SHOW_SPINNER");
            
            if(this.chips)
                this.form.options = this.chips
            try {
                if (this.item) {
                    await this.$api.core.extraField.edit({
                        ...this.form,
                    });
                } else {
                    await this.$api.core.extraField.create({
                        ...this.form,
                    });
                }

                this.show = false;

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: this.$t('message.successMessages.message.recordSaved'),
                });

                this.$emit("submit");
            } catch (error) {
                console.log(error);
            } finally {
                EventBus.$emit("CANCEL_SPINNER");
            }
        },
        setLabel() {
            if(!this.form.label) {
                this.form.label = this.form.name
            }
        }

    },
};
</script>

<style lang="scss" scoped>
.extra-field-create-activator {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    margin-left: 25px;

    .extra-field-create-activator-icon {
        display: flex;
        align-items: center;
        margin-right: 5px;
    }
}

.form-body {
    padding: 18px 50px 10px;
}

.checkbox-controller {
    margin-top: 13px;
}

.btn {
    margin-right: 10px;
}

.type-mask {
    display: inline;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
}

.type-body {
    display: inline;
    align-items: center;
    justify-content: center;
}

.card-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 15px;

    .btn {
        margin: 15px;
    }
}

.modal-round .v-card .card-body {
    min-height: 160px;
    overflow-x: hidden;
}




.chips-container {
            display: flex;
            align-items: center;
            /* box-shadow: rgb(60 64 67 / 30%) 0px 1px 2px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px; */
            padding: 4px;
            min-height: 34px;
            justify-content: space-between;

        }

        .chips-inner-container {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            width: 100%;
        }

        .chips-wrapper {
            display: flex;
            flex-wrap: wrap;
        }

        input {
            flex: 1 1 auto;
            width: 300px;
            border: none;
            outline: none;
            padding: 12px;
        }

        .chip {
            border-radius: 28px;
            padding: 8px 12px;
            margin: 2px 4px;
            display: flex;
            align-items: center;
            color: #707070;
            background-color: #fff;
            max-height: 30px;
            max-width: fit-content;
            border: 1px solid #D6D6D6;
            font-size: 14px;
        }

        .v-chip-close,
        .all-chip-close {
            align-items: center;
            color: inherit;
            display: flex;
            font-size: 15px;
            margin: 0 2px 0 8px;
            text-decoration: none;
            cursor: pointer;
        }

        .v-chip-close span,
        .all-chip-close {
            color: inherit;
            font-size: 20px;
            cursor: pointer;
            opacity: .5;
        }

        .v-chip-close span:hover {
            opacity: 1;
        }

        .all-chip-close:hover {
            opacity: 1;
        }
</style>
